/**
 * Created by ferto
 * Marciano Digital Agency
 * www.marciano.com.mx
 * Date: 01/02/2018.
 *
 * index Vue Store
 */
import BaseStore from '@/store/base-store'

const options = {
  mutations: {
    items (state, items) {
      for (let item of items) {
        item.startDate = item.startDate || item.assignment.startDate
        item.endDate = item.endDate || item.assignment.endDate
      }
      state.items = items
    }
  }
}
export default new BaseStore('evaluations', options)



// WEBPACK FOOTER //
// ./src/store/evaluations/index.js